import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="ftco-footer ftco-section relative">
     
      <div className="container">
        <div className="row">

          <div className="col-lg-3 col-md-6  text-left">
            <div className="ftco-footer-widget mb-4">
              <h2 className="ftco-heading-2">About Us</h2>
              <p>
              Coffee powder produced from the best quality coffee beans will change your life. 
              Happiness will be with you


              </p>
              <ul className="ftco-footer-social list-unstyled mt-5 float-md-left float-left">
                <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="icon-twitter text-center text-decoration-none lh-extra"></a></li>
                <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="icon-facebook text-center text-decoration-none lh-extra"></a></li>
                <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="icon-instagram text-center text-decoration-none lh-extra"></a></li>
              </ul>
            </div>
          </div>


          <div className="col-lg-3 col-md-6  mb-md-5 text-left">
            <div className="ftco-footer-widget mb-4 ml-md-4">
              <h2 className="ftco-heading-2">Quick Links</h2>
              <ul className="list-unstyled text-decoration-none">
                {[
                  { name: "Home", path: "/" },
                  { name: "Shop", path: "/shop" },
                  { name: "About", path: "/about" },
                  { name: "Contact", path: "/contact" }
                ].map((link, index) => (
                  <li key={index}>
                    <Link to={link.path} className="mb-1 text-decoration-none">
                      <p>{link.name}</p>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>


          <div className="col-lg-3 col-md-6  mb-md-5 text-left">
            <div className="ftco-footer-widget mb-4 md-4">
              {/* <h2 className="ftco-heading-2"></h2><br /> */}
              <ul className="list-unstyled text-decoration-none">
                {[
                   { name: "Became a reseller", path: "/" },
                   { name: "Terms & Conditions", path: "/termsandconditions" },
                   { name: "Refund Policy", path: "/refund-policy" },
                   { name: "Shipping Policy", path: "/shipping-policy" },
                   { name: "Privacy Policy", path: "/privacy-policy" }
                  
                  
                ].map((link, index) => (
                  <li key={index}>
                    <Link to={link.path} className="mb-1 text-decoration-none">
                      <p>{link.name}</p>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact Section */}
          <div className="col-lg-3 col-md-6  mb-md-5 text-left">
            <div className="ftco-footer-widget mb-4">
              <h2 className="ftco-heading-2">Have a Questions?</h2>
              <div className="block-23 mb-3">
                <ul>
                  <li>
                    <span className="icon icon-map-marker"></span>
                    <span className="text">
                      AUWM Compound Vengeri ,

                      Building No: 9/2467 (H4), Calicut / Kakkodi road, Calicut dist. </span>
                  </li>
                  <li>
                    <a href="tel:00917510266377" className="text-decoration-none mb-0">
                      <span className="icon icon-phone"></span>
                      <span className="text"> +91 7510266377</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:njsgroupwayanad@gmail.com" className="text-decoration-none">
                      <span className="icon icon-envelope"></span>
                      <span className="text"> njsgroupwayanad@gmail.com </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 text-center">
            <p>
              Copyright &copy; {new Date().getFullYear()} All rights reserved
              by &nbsp;
              <a href="https://www.axobis.com" target="_blank" rel="noopener noreferrer">
                Axobis
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
